<template>
  <div class="container">
    <div class="bind__header">
      <div class="bind__header__info">
        <span class="bind__header__info__title">绑定车牌</span>
        <span class="bind__header__info__content">点击查看已绑车辆</span>
        <van-button type="primary" color="#4897FA" to="my-car" size="small">查看已绑</van-button>
      </div>
      <div class="bind__header__2dpic" :style="{
          backgroundImage:
            'url(' + require('@/assets/payment-related/BD_carbanner.png') + ')'
        }"></div>
    </div>
    <div class="bind-modal">
      <div class="title">
        请输入您的车牌号进行绑定
      </div>
      <div class="page page-index">
        <keyboard :plateNumber.sync="plateNumber" @change="change"></keyboard>
      </div>
      <div class="btn_box">
        <van-button @click="createPlateNumber" size="large" class="blue-btn">确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import keyboard from '@/components/keyboard/index'
import { Dialog } from 'vant'
import { addCarAndUserRel } from '@/api/park'
import { parseTime } from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'BindCar',
  components: {
    keyboard,
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    ...mapGetters(['wx_userInfo', 'token', 'backflow'])
  },
  data () {
    return {
      getInfo_Loading: null,
      plateNumber: []
    }
  },
  methods: {
    // 新增车牌
    createPlateNumber () {
      let _this = this
      _this.getInfo_Loading = _this.$toast.loading('加载中...')
      if (!_this.plateNumber.join('')) {
        _this.$toast('请输入车牌号！')
        return
      }
      let plateNumberReg = new RegExp(
        '^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$'
      )
      if (!plateNumberReg.test(_this.plateNumber.join(''))) {
        _this.$toast('请输入正确的车牌号！')
        return
      }
      let params = {
        cardNumber: _this.plateNumber.join(''),
        openid: _this.wx_userInfo ? _this.wx_userInfo.openid : '',
        addTime: parseTime(new Date())
      }
      addCarAndUserRel(params)
        .then(response => {
          if (response.status === 1001) {
            Dialog.alert({
              title: '添加成功',
              message: `车牌${_this.plateNumber.join('')}绑定成功`,
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: '立即缴费',
              cancelButtonText: '返回'
            })
              .then(() => {
                // on close
                _this.$router.push({
                  name: _this.backflow ? _this.backflow : 'My-Order',//返回跳转来源
                  query: {
                    cardNumber: _this.plateNumber.join('')
                  }
                })
              })
              .catch(() => {
                _this.$router.push({
                  name: 'My-Car'
                })
              })
            _this.$toast.success('添加成功')
          }
        })
        .catch(error => {
          _this.getInfo_Loading.clear()
          _this.$notify({
            type: 'danger',
            message: error
          })
        })
    },
    change (val) {
      this.plateNumber = val
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #f5f5f5;
  position: relative;

  .bind__header {
    display: flex;
    flex-direction: colunm;
    flex-wrap: wrap;
    padding: 25px;
    background: linear-gradient(
      -52deg,
      rgba(26, 73, 251, 1),
      rgba(71, 140, 245, 1)
    );

    &__info {
      width: 50%;
      color: rgba(255, 255, 255, 1);

      span {
        display: block;
      }

      &__title {
        font-size: 17px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        line-height: 26px;
      }

      &__content {
        font-size: 14px;
        line-height: 38px;
      }
    }

    &__2dpic {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 50%;
      height: 20vh;
      min-height: 140px;
    }
  }

  .bind-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 600px;
    max-width: 90%;
    height: 60vh;
    min-height: 400px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(37, 44, 63, 0.1);
    border-radius: 5px;
    margin: 25vh auto 0;

    .title {
      text-align: center;
      font-size: 17px;
      line-height: 1.5;
      line-height: 1.5;
      padding: 25px 0 10px;
    }

    .btn_box {
      padding: 0 15px;
    }

    .page {
      padding: 10px;
    }
  }
}
</style>